import { render, staticRenderFns } from "./SoundEditor.vue?vue&type=template&id=10caba52&scoped=true"
import script from "./SoundEditor.vue?vue&type=script&lang=ts"
export * from "./SoundEditor.vue?vue&type=script&lang=ts"
import style0 from "./SoundEditor.vue?vue&type=style&index=0&id=10caba52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10caba52",
  null
  
)

export default component.exports